import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { useSelector } from 'react-redux';

// GLOBAL COMPONENTS
import NoResults from 'core/tools/NoResults';

// LOCAL COMPONENTS
import DesktopTable from './desktop/Table';
import MobileList from './mobile/List';

// HELPERS
import { useListData } from 'helpers/getListData';

// STYLES
import styles from './desktop/table.module.scss';

// MAIN COMPONENT
export default function TableContainer(props) {
  const {
    loading, //
    result: data = [],
    heading
  } = Object.assign(useListData() || {}, props);

  return (
    <>
      {heading && <h3 className={clsx('text-uppercase', styles.heading)}>{heading}</h3>}
      {data?.length ? (
        <Table {...props} />
      ) : (
        <NoResults
          icon={loading ? 'clock' : 'mood-bad'}
          className="flex-grow-1 d-flex flex-column justify-content-center"
        >
          {loading ? 'Loading...' : 'No Results Found'}
        </NoResults>
      )}
    </>
  );
}

function Table(props) {
  const isMobile = useSelector(state => state.mobile?.mobile);

  return isMobile ? <MobileList {...props} /> : <DesktopTable {...props} />;
}
